export default {
    methods: {
        serviceIdToLink(serviceId) {
            serviceId = parseInt(serviceId, 10);
            
            switch (serviceId) 
            {
                case 3: return '/declaration';
                case 5: return '/declaration';
                case 8: return '/declaration-trader';
                case 9: return '/declaration-trader';
                case 10: return '/declaration-docs';
                case 13: return '/declaration-fast';
                case 17: return '/declaration-turnkey';
                case 18: return '/declaration-concierge';
                case 19: return '/declaration-super';
                case 22: return '/declaration-concierge';
                case 23: return '/declaration-trader';
                case 24: return '/declaration-solution';
                case 25: return '/declaration-ta';
                case 26: return '/declaration-ta';
                case 27: return '/declaration-ta';
                case 29: return '/declaration-turnkey';
                case 30: return '/declaration-turnkey';
                case 31: return '/declaration-turnkey';
                case 32: return '/declaration-turnkey';
                case 33: return '/declaration-turnkey';
                case 34: return '/declaration-turnkey';
                case 35: return '/declaration-docs-paid';
                case 36: return '/declaration-docs-paid';
                case 37: return '/declaration-turnkey';
                case 38: return '/declaration-solution';
                case 39: return '/declaration-consultation';
                case 40: return '/declaration-fast';
                case 41: return '/declaration-docs-paid';
                case 42: return '/declaration-consultation';
                
                default: return '/declaration';
            }
        },

        serviceIdToTitle(serviceId) {
            serviceId = parseInt(serviceId, 10);
            
            switch (serviceId) 
            {
                case 3: return 'Заполнение декларации';
                case 5: return 'Заполнение и подача декларации';
                case 8: return 'Налоговый консьерж ПЛЮС для трейдеров';
                case 9: return 'Декларация для трейдера';
                case 10: return 'Проверка документов';
                case 13: return 'Максимальный вычет';
                case 17: return 'Корректировка';
                case 18: return 'Налоговый консьерж 1 год';
                case 19: return 'Супервычет';
                case 22: return 'Налоговый консьерж 1 месяц';
                case 23: return 'Налоговый консьерж для трейдеров';
                case 24: return 'Успешное Решение';
                case 25: return 'Отчет о движении денежных средств';
                case 26: return 'Расчет торговых операций / учет дивидендов';
                case 27: return 'Уведомление об открытии / закрытии счёта';
                case 29: return 'Вычет под ключ';
                case 30: return 'Вычет под ключ';
                case 31: return 'Вычет под ключ';
                case 32: return 'Социальная декларация для налогового консьержа';
                case 33: return 'Вычет под ключ';
                case 34: return 'Вычет под ключ';
                case 35: return 'Поиск выгоды';
                case 36: return 'VIP консультация по налогам';
                case 37: return 'Декларация за 1 день';
                case 38: return 'Успешное Решение. Поиск выгоды';
                case 39: return 'Бесплатная консультация';
                case 40: return 'Максимальный вычет';
                case 41: return 'Ускоренный возврат';
                case 42: return 'Страхование';
                
                default: return '';
            }
        },
    }
}
